import { IDropdownProps, ITextOutputProps, TextOutput } from '..';
import { toListItemValue } from '../Dropdown/shared';
import { withInjectedProps } from '../InjectedPropsContext';

type IFixedOptionTextOutputProps = {
  options?: IDropdownProps['options'];
  isMulti?: IDropdownProps['isMulti'];
} & ITextOutputProps;

/**
 * Provides a TextOutput component
 * that takes its value as the label of the list item matching the current selection
 *
 * Provides a "display" version of a field that would be entered as a dropdown component
 * (where the options are fixed properties and do not need to be queried for)
 */
let FixedOptionTextOutput: React.FC<IFixedOptionTextOutputProps> = ({
  options,
  value,
  isMulti,
  ...textOutputProps
}) => {
  const listItemValue = toListItemValue({ options, value, isMulti });
  const textValue = Array.isArray(listItemValue) ? listItemValue.map((v) => v.label).join(', ') : listItemValue?.label;

  return <TextOutput value={textValue} {...textOutputProps} />;
};

FixedOptionTextOutput = withInjectedProps(FixedOptionTextOutput);

export { FixedOptionTextOutput };
export default FixedOptionTextOutput;
